import { useState } from "react";
import { toast } from "sonner";

const inp = "border-2 border-[#D3CFC0] bg-white px-2 py-1.5 text-sm focus:border-[#1E1E1E] outline-none";
const btn = "px-3 py-1.5 font-head uppercase text-xs border-2 transition-colors";

export default function ReviewPanel({ api, item, opts, onDone }) {
  const [name, setName] = useState(localStorage.getItem("sk_reviewer") || "Coach Kyto");
  const [scope, setScope] = useState("all");
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const gated = item.sports.some((s) => opts.requires_second_reviewer.includes(s));

  const run = async (path, body, okMsg) => {
    setBusy(true);
    try {
      localStorage.setItem("sk_reviewer", name);
      const { data } = await api.post(`/admin/starter-kit/items/${item.id}/${path}`, body);
      toast.success(data.message || okMsg);
      await onDone();
    } catch (e) { toast.error(e.response?.data?.detail?.[0]?.msg || e.response?.data?.detail || "Action failed"); }
    finally { setBusy(false); }
  };

  return (
    <div className="border-t-2 border-dashed border-[#D3CFC0] pt-3 space-y-3" data-testid="sk-review-panel">
      <div className="text-xs text-[#6E6E6E] space-y-1">
        <p>Approvals: {item.approvals.length ? item.approvals.map((a) => `${a.name} (${a.sport_scope})`).join(", ") : "none"}</p>
        <p>Assigned reviewers: {item.assigned_reviewers.length ? item.assigned_reviewers.map((a) => `${a.name} (${a.sport_scope})`).join(", ") : "none"}</p>
        {gated && <p className="text-[#DB9130]">Needs 2 approvals, including one reviewer scoped to {item.sports.join("/")}.</p>}
        {item.founder_written && <p className="text-[#DB9130]">Founder-written: approve by hand only after you've rewritten it in your voice.</p>}
      </div>
      <div className="flex flex-wrap gap-2 items-center">
        <input data-testid="sk-reviewer-name" value={name} onChange={(e) => setName(e.target.value)} placeholder="Reviewer name" className={inp} />
        <select data-testid="sk-reviewer-scope" value={scope} onChange={(e) => setScope(e.target.value)} className={inp}>
          <option value="all">Scope: all sports</option>
          {opts.sports.map((s) => <option key={s} value={s}>{`Scope: ${s}`}</option>)}
        </select>
        <button data-testid="sk-item-approve" disabled={busy || !name} onClick={() => run("approve", { name, sport_scope: scope }, "Approved")}
          className={`${btn} bg-[#1E1E1E] border-[#1E1E1E] text-[#F3F1EC] hover:bg-[#DB9130] hover:border-[#DB9130] hover:text-[#1E1E1E]`}>Approve</button>
        <button data-testid="sk-item-assign" disabled={busy || !name} onClick={() => run("assign", { name, sport_scope: scope }, "Reviewer assigned")}
          className={`${btn} border-[#1E1E1E] text-[#1E1E1E] hover:bg-[#F3F1EC]`}>Assign reviewer</button>
      </div>
      <div className="flex flex-wrap gap-2 items-center">
        <input data-testid="sk-reject-reason" value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Reason (optional)" className={`${inp} flex-1 min-w-[200px]`} />
        <button data-testid="sk-item-reject" disabled={busy} onClick={() => run("reject", { reason }, "Rejected")}
          className={`${btn} border-[#B3261E] text-[#B3261E] hover:bg-[#B3261E] hover:text-white`}>Reject</button>
        <button data-testid="sk-item-reset" disabled={busy} onClick={() => run("reset", {}, "Reverted to the original draft")}
          className={`${btn} border-[#D3CFC0] text-[#6E6E6E] hover:border-[#1E1E1E]`}>Revert to original</button>
      </div>
    </div>
  );
}
